import {
  type Dispatch,
  type SetStateAction,
  type FC,
  type ReactNode,
  useEffect,
} from 'react';
import { observer } from 'mobx-react';
import { mobileHeaderHeight } from '../../layouts/theme';
import { useStores } from '../../../utils/hooks/useStores';
import { MobileStickyHeader } from './MobileStickyHeader';
import type { PageTab } from 'src/App/CandidateManagementPage/PageTabs';

const MOBILE_NAVIGATION_SELECTOR = '#employer-header-mobile-navigation';

interface StickyHeaderProps {
  isAtTopOfPage: boolean;
  setIsAtTopOfPage: Dispatch<SetStateAction<boolean>>;
  selectedPageTab: PageTab;
  setSelectedPageTab: (tab: PageTab) => void;
  isStickyOnDesktop: boolean;
  setIsStickyOnDesktop: Dispatch<SetStateAction<boolean>>;
  employerHeader: ReactNode;
}

const StickyHeader: FC<StickyHeaderProps> = ({
  isAtTopOfPage,
  isStickyOnDesktop,
  selectedPageTab,
  setIsAtTopOfPage,
  setIsStickyOnDesktop,
  setSelectedPageTab,
  employerHeader,
}) => {
  const { isMobile } = useStores();

  const updateEmployerHeaderMobileNavigationHeight = () => {
    const employerHeaderMobileNavigation = document.querySelector(
      MOBILE_NAVIGATION_SELECTOR,
    ) as HTMLElement;
    if (employerHeaderMobileNavigation) {
      employerHeaderMobileNavigation.style.height = `${
        window.innerHeight - mobileHeaderHeight
      }px`;
    }
  };

  useEffect(() => {
    updateEmployerHeaderMobileNavigationHeight();
    window.addEventListener(
      'resize',
      updateEmployerHeaderMobileNavigationHeight,
    );
    return function cleanup() {
      window.removeEventListener(
        'resize',
        updateEmployerHeaderMobileNavigationHeight,
      );
    };
  });

  if (isMobile) {
    return (
      <MobileStickyHeader
        selectedPageTab={selectedPageTab}
        setSelectedPageTab={setSelectedPageTab}
        isStickyOnDesktop={isStickyOnDesktop}
        setIsStickyOnDesktop={setIsStickyOnDesktop}
        isAtTopOfPage={isAtTopOfPage}
        setIsAtTopOfPage={setIsAtTopOfPage}
        employerHeader={employerHeader}
      />
    );
  }

  return employerHeader;
};

export default observer(StickyHeader);
